'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var PropTypes = require('prop-types');
var areEqual = require('fbjs/lib/areEqual');
var deepFreeze = require('deep-freeze');

/**
 * Taken from react-relay QueryRenderer with one addition.
 * - lookup prop will check the relay store for data first and if present will
 * immediately call `render` with props.
 *
 * This will not be necessary if this PR is merged:
 * https://github.com/facebook/relay/pull/1760
 */

var ReactRelayQueryRenderer = function (_React$Component) {
    _inherits(ReactRelayQueryRenderer, _React$Component);

    function ReactRelayQueryRenderer(props, context) {
        _classCallCheck(this, ReactRelayQueryRenderer);

        var _this = _possibleConstructorReturn(this, (ReactRelayQueryRenderer.__proto__ || Object.getPrototypeOf(ReactRelayQueryRenderer)).call(this, props, context));

        _this._onChange = function (snapshot) {
            _this.setState({
                readyState: _extends({}, _this.state.readyState, {
                    props: snapshot.data
                })
            });
        };

        var query = props.query,
            variables = props.variables,
            lookup = props.lookup;

        var environment = props.environment;
        var operation = null;
        if (query) {
            var _environment$unstable = environment.unstable_internal,
                createOperationSelector = _environment$unstable.createOperationSelector,
                getOperation = _environment$unstable.getOperation;

            query = getOperation(query);
            operation = createOperationSelector(query, variables);
            variables = operation.variables;
        }

        _this._mounted = false;
        _this._operation = operation;
        _this._pendingFetch = null;
        _this._relayContext = {
            environment: environment,
            variables: variables
        };
        _this._rootSubscription = null;
        _this._selectionReference = null;

        if (operation) {
            if (lookup && environment.check(operation.root)) {
                // data is available in the store, render without making any requests
                var snapshot = environment.lookup(operation.fragment);
                _this.state = {
                    readyState: {
                        error: null,
                        props: snapshot.data,
                        retry: function retry() {
                            _this._fetch(operation, props.cacheConfig);
                        }
                    }
                };
            } else {
                _this.state = {
                    readyState: getDefaultState()
                };
                _this._fetch(operation, props.cacheConfig);
            }
        } else {
            _this.state = {
                readyState: {
                    error: null,
                    props: {},
                    retry: null
                }
            };
        }
        return _this;
    }

    _createClass(ReactRelayQueryRenderer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this._mounted = true;
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if (nextProps.query !== this.props.query || nextProps.environment !== this.props.environment || !areEqual(nextProps.variables, this.props.variables)) {
                var query = nextProps.query,
                    variables = nextProps.variables;

                var environment = nextProps.environment;
                if (query) {
                    var _environment$unstable2 = environment.unstable_internal,
                        createOperationSelector = _environment$unstable2.createOperationSelector,
                        getOperation = _environment$unstable2.getOperation;

                    var operation = createOperationSelector(getOperation(query), variables);
                    this._operation = operation;
                    this._relayContext = {
                        environment: environment,
                        variables: operation.variables
                    };
                    if (nextProps.lookup && environment.check(operation.root)) {
                        var snapshot = environment.lookup(operation.fragment);
                        this.setState({
                            readyState: {
                                error: null,
                                props: snapshot.data,
                                retry: function retry() {
                                    _this2._fetch(operation, nextProps.cacheConfig);
                                }
                            }
                        });
                    } else {
                        this._fetch(operation, nextProps.cacheConfig);
                        this.setState({
                            readyState: getDefaultState()
                        });
                    }
                } else {
                    this._operation = null;
                    this._relayContext = {
                        environment: environment,
                        variables: variables
                    };
                    this._release();
                    this.setState({
                        readyState: {
                            error: null,
                            props: {},
                            retry: null
                        }
                    });
                }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this._release();
            this._mounted = false;
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return nextProps.render !== this.props.render || nextState.readyState !== this.state.readyState;
        }
    }, {
        key: '_release',
        value: function _release() {
            if (this._pendingFetch) {
                this._pendingFetch.dispose();
                this._pendingFetch = null;
            }
            if (this._rootSubscription) {
                this._rootSubscription.dispose();
                this._rootSubscription = null;
            }
            if (this._selectionReference) {
                this._selectionReference.dispose();
                this._selectionReference = null;
            }
        }
    }, {
        key: '_fetch',
        value: function _fetch(operation, cacheConfig) {
            var _this3 = this;

            var environment = this._relayContext.environment;

            // Immediately retain the results of the new query to prevent relevant data
            // from being freed. This is not strictly required if all new data is
            // fetched in a single step, but is necessary if the network could attempt
            // to incrementally load data (ex: multiple query entries or incrementally
            // loading records from disk cache).

            var nextReference = environment.retain(operation.root);

            var readyState = getDefaultState();
            var snapshot = void 0; // results of the root fragment
            var onCompleted = function onCompleted() {
                _this3._pendingFetch = null;
            };
            var onError = function onError(error) {
                readyState = {
                    error: error,
                    props: null,
                    retry: function retry() {
                        _this3._fetch(operation, cacheConfig);
                    }
                };
                if (_this3._selectionReference) {
                    _this3._selectionReference.dispose();
                }
                _this3._pendingFetch = null;
                _this3._selectionReference = nextReference;
                _this3.setState({ readyState: readyState });
            };
            var onNext = function onNext() {
                // `onNext` can be called multiple times by network layers that support
                // data subscriptions. Wait until the first payload to render `props` and
                // subscribe for data updates.
                if (snapshot) {
                    return;
                }
                snapshot = environment.lookup(operation.fragment);
                readyState = {
                    error: null,
                    props: snapshot.data,
                    retry: function retry() {
                        _this3._fetch(operation, cacheConfig);
                    }
                };

                if (_this3._selectionReference) {
                    _this3._selectionReference.dispose();
                }
                _this3._rootSubscription = environment.subscribe(snapshot, _this3._onChange);
                _this3._selectionReference = nextReference;
                _this3.setState({ readyState: readyState });
            };

            if (this._pendingFetch) {
                this._pendingFetch.dispose();
            }
            if (this._rootSubscription) {
                this._rootSubscription.dispose();
            }
            var request = environment.streamQuery({
                cacheConfig: cacheConfig,
                onCompleted: onCompleted,
                onError: onError,
                onNext: onNext,
                operation: operation
            });
            this._pendingFetch = {
                dispose: function dispose() {
                    request.dispose();
                    nextReference.dispose();
                }
            };
        }
    }, {
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                relay: this._relayContext
            };
        }
    }, {
        key: 'render',
        value: function render() {
            // Note that the root fragment results in `readyState.props` is already
            // frozen by the store; this call is to freeze the readyState object and
            // error property if set.
            if (process.env.NODE_ENV !== 'production') {
                deepFreeze(this.state.readyState);
            }
            return this.props.render(this.state.readyState);
        }
    }]);

    return ReactRelayQueryRenderer;
}(React.Component);

ReactRelayQueryRenderer.childContextTypes = {
    relay: PropTypes.object.isRequired
};

function getDefaultState() {
    return {
        error: null,
        props: null,
        retry: null
    };
}

module.exports = ReactRelayQueryRenderer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/relay-query-lookup-renderer/dist/index.js
// module id = ./node_modules/relay-query-lookup-renderer/dist/index.js
// module chunks = 4